exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#people{padding-top:0}#people .item{margin:0}#people .item-text.full-height h5{font-size:20px;font-weight:700;text-transform:uppercase;letter-spacing:5px}#people .item-text.full-height p{letter-spacing:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./assets/component/about/teams.vue
// module id = 275
// module chunks = 0